import { FieldModel } from '@cibo/core'
import { CoverCropCellDisplay } from '@cibo/landmanager'
import { TraitCellContainer } from './TraitCellContainer'

interface CoverCropCellProps {
  value: any
  task: any
  year: number
  selectedField: FieldModel | null
}

export const CoverCropCell = ({ value, task, year, selectedField }: CoverCropCellProps) => {
  return (
    <TraitCellContainer
      value={value}
      task={task}
      selectedField={selectedField}
      year={year}
      traitId="coverCrop"
    >
      <CoverCropCellDisplay value={value} />
    </TraitCellContainer>
  )
}
